import { render } from "./PantryFoodItem.vue?vue&type=template&id=465dbcb1&ts=true"
import script from "./PantryFoodItem.vue?vue&type=script&lang=ts"
export * from "./PantryFoodItem.vue?vue&type=script&lang=ts"

import "./PantryFoodItem.vue?vue&type=style&index=0&id=465dbcb1&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__